<template>
  <div class="to_do_today salebench_com">
    <div class="btn">
        <el-button class="funcPublicBtn funcPublicBtnChecked" v-if="module.indexOf(',customer-visit-edit,')!=-1" @click="linkTo" size="mini">处理待办</el-button>
        <el-checkbox v-model="checked" class="filter" @change="onlyShowTodo">今日待办</el-checkbox>
    </div>
    <el-table id="table" class="table to_do_table" ref="singleTable" :data="todoData"  v-loading = "isLoading" element-loading-background = "rgba(0, 0, 0, 0.3)" element-loading-text = "数据正在加载中" element-loading-spinner = "el-icon-loading"  @row-click="handleRowClick" border stripe highlight-current-row  size="mini" style="width: 1000px;" height="100%">
        <el-table-column label="选择" width="45" align="center">
            <template v-slot="scope">
                <el-checkbox v-model="scope.row.checked"></el-checkbox>
                <div class="hideBox"></div>
            </template>
        </el-table-column>
      <el-table-column prop="name" label="客户名称" width="180" show-overflow-tooltip>
        <template v-slot="scope">
          <span class="link" @click="linkToInfo(scope.row.customer_id, scope.row.name)">{{scope.row.name}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="reminder_date" label="待办日期" width="150"></el-table-column>
      <el-table-column prop="remind" label="待办内容" show-overflow-tooltip></el-table-column>
    </el-table>
    <div class="pag">
      <pagination v-if="refresh" ref="pagination" :lastpages.sync="pages.last_page" :currentpages.sync="pages.current_page" :all.sync="pages.total" :pagesizes.sync="pages.per_page" @getPage="getPage"></pagination>
    </div>
    <el-dialog v-dialog-drag title="处理待办事项" class="handleTodo" :visible.sync="dialogFormVisible" @close="closeEvent" width="500px">
        <el-form :model="form" :rules="formRule" ref="ruleForm">
            <el-form-item :label="reminder_date? '待办内容('+ reminder_date +')' : '待办内容'" label-width="180">
                <el-input type="textarea" :rows="3" placeholder="请输入内容" v-model="form.content"></el-input>
            </el-form-item>
            <el-form-item :label="'待办结果('+ today +')'" label-width="180" prop="result">
                <el-input type="textarea" :rows="3" placeholder="请输入内容" v-model="form.result"></el-input>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button class="benchBtn" @click="resetForm('ruleForm')">取 消</el-button>
            <el-button type="primary" class="benchBtn benchBtnChecked" @click="save('ruleForm')">确定保存</el-button>
        </div>
    </el-dialog>
  </div>
</template>

<script>
import pagination from '../../../../components/pagination' 
import eventBus from '../../../../eventBus'
export default {
    components: {
        pagination
    },
    props: {
        todoData: {
            type: Array,
            default(){
                return []
            }
        },
        pages: {
            type: Object,
            default(){
                return {
                    last_page: 0,
                    total: 0,
                    current_page: 1,
                    per_page: 20
                }
            }
        },
        isLoading:{
            type:Boolean
        }
    },
    data(){
        return {
            module:localStorage.dw_erp_power_code,
            multipleSelection: [],
            selectRow: [],
            selectData: [],
            checked: false,
            dialogFormVisible: false,
            form: {
                content:  '',
                result: ''
            },
            formRule: {
                result: [
                    { required: true, message: '请填写待办结果', trigger: 'change' }
                ]
            },
            refresh: true,
            today: this.formatTime(new Date()),
            reminder_date: '',
            id: '',
            currentRow: null
        }
    },
    methods: {
        //行点击事件  待删除
        setCurrent(row) {
            this.$refs.singleTable.setCurrentRow(row);
        },    
        handleRowClick(row){
            this.$emit("singleSelected", row.id)
            if(this.currentRow == row){
                this.currentRow = null
                row.checked = false
                this.setCurrent()
            }else{
                row.checked = true
                this.form.content = row.remind
                this.id = row.id
                this.currentRow = row
            }
        },
        //处理待办
        linkTo(){
            if(this.currentRow == null){
                this.tip("请选择待办内容",'warning')
                return
            }
            this.dialogFormVisible = true
        },
        //分页
        getPage(obj){
            this.$emit('todoPageChangeEvent', obj)
            this.currentRow = null
        },
        //跳转至客户页
        linkToInfo(id, name){
            localStorage.setItem("dw_erp_customer_id",id);
            localStorage.setItem("dw_erp_customer_name_workbench", name)
            this.$emit('todoHandle')
        },
        //只看今日待办
        onlyShowTodo(){
            let obj = {}
            obj.is_today = this.checked ? 0 : 1
            this.$emit('filterTodayEvent',obj)
            this.currentRow = null
        },
        //保存
        save(formName){          
            this.$refs[formName].validate((valid) => {
                if (valid) {       
                    this.postFunc('erp/customer.visit.dbacklog', {id: this.id, result: this.form.result},()=>{
                        this.$emit("refreshTodoList")  //更新列表数据 事件触发
                        this.dialogFormVisible = false
                    })
                } else {
                    return false;
                }
            });
        },
        //取消
        resetForm(formName) {
            this.$refs[formName].resetFields();
            this.dialogFormVisible = false
        },
        //对话框关闭事件回调
        closeEvent(){
            this.$refs['ruleForm'].resetFields();
        },
        // selectbox change event in table
        checkedChangeEvent(row){
            this.$emit("singleSelected", row.id)
            if(row.checked){
                this.form.content = row.remind
                this.id = row.id
                this.currentRow = row
            }else{
                this.currentRow = null
            }
        },
        clearSelected(){
            this.currentRow = null
        }
    },
    watch: {
        selectData(data){
            this.selectRow = [];
            if(data.length>0){
                data.forEach(item=>{
                    this.selectRow.push(item.id);
                })
            }
        },
        pages(){
            //强制刷新组件
            this.refresh= false
            this.$nextTick(()=>{
                this.refresh = true
            })
        }   
    },
    created(){
        let now = new Date()
        let year = now.getFullYear(); //得到年份
        let month = now.getMonth();//得到月份
        let date = now.getDate();//得到日期
        month = month + 1;
        if (month < 10) month = "0" + month;
        if (date < 10) date = "0" + date;
        this.today = year + '-' + month + '-' + date
        eventBus.$on('clearToDoSelected', this.clearSelected)
    },
    destroyed(){
        eventBus.$off('clearToDoSelected')
    }
}
</script>

<style lang="scss" scoped>
.to_do_today{
    display: flex;
    flex-direction: column;
    height: 100%;
    text-align: left;
    .btn{
        .filter{
            position: relative;
            top: 10px;
            left: 10px;
            margin-bottom: 10px;
        }
    }
    .table{
        flex: 1;
        margin-top: 5px;
        .link{
            color: #0099ff;
            cursor: pointer;
        }
        .link:hover{
            text-decoration: underline;
        }
        .hideBox{
            width: 30px;
            height: 30px;
            position: absolute;
            top: 0;
            left: 0;
            z-index: 100;
            background: transparent;
        }
    }
    .pag{
        width: 1000px;
        text-align: center;
        margin-bottom: 10px;
    }
}
.handleTodo /deep/ .el-dialog__header{
    font-weight: 600;
}
.handleTodo /deep/ .el-textarea__inner{
  border-color: #333;
  font-size: 12px;
}
.to_do_today /deep/ .el-table__body tr.current-row>td{
  background-color: rgba(255, 235, 188, 0.75) !important;
}
.to_do_today /deep/ .el-table--border, .to_do_today /deep/ .el-table--group {border: 1px solid #fff;}
.to_do_today /deep/  .el-table--border th.gutter:last-of-type {border-bottom-color: #fff;}

</style>